@if (routed()) {
  <!-- Routed mode — registry-fed <a routerLink> tabs with aria-current.
       The content-switch tabs/activeId API is ignored in this mode. -->
  <tw-nav-tabs [navId]="navId()!" />
} @else {
  <tw-tabs
    [tabs]="tabs()"
    [activeId]="activeId()"
    (activeIdChange)="onActiveIdChange($event)"
  />
}
